<template>
  <section>
    <fieldset :disabled="isScenarioReadonly || isImportedFromLegacy">
      <WellCompletion v-if="isEspOnShore" />
      <WellTest />
      <FluidProperties :isEspOnShore="isEspOnShore" />
      <GasProperties v-if="isEspOnShore || isHPSMultiphase" />
    </fieldset>
    <CorrelationsForm />
  </section>
</template>

<script setup lang="ts">
import WellCompletion from "@/views/scenarios/wellInfo/WellCompletion.vue";
import WellTest from "@/views/scenarios/wellInfo/WellTest.vue";
import FluidProperties from "@/views/scenarios/wellInfo/FluidProperties.vue";
import GasProperties from "@/views/scenarios/wellInfo/GasProperties.vue";
import CorrelationsForm from "@/views/scenarios/wellInfo/Correlations.vue";
import { useEditPermissions } from "@/composables/auth/editPermissions";
import { injectStrict } from "@/utils/utils";
import {
  sizingFormKey,
  wellPropertiesFormKey
} from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { computed } from "vue";
import { Hps_Liquid_Type_Enum, Sizing_Pumping_Type_Enum } from "gql/api";

const sizingForm = injectStrict(sizingFormKey, null);
const wellPropertiesForm = injectStrict(wellPropertiesFormKey);

const isEspOnShore = computed(() => {
  return (
    sizingForm?.data.value.pumping_type === Sizing_Pumping_Type_Enum.EspOnShore
  );
});

const isHPSMultiphase = computed(() => {
  return (
    wellPropertiesForm.data.value?.hps_liquid_type ===
      Hps_Liquid_Type_Enum.Multiphase ||
    wellPropertiesForm.data.value?.hps_liquid_type ===
      Hps_Liquid_Type_Enum.Condensate ||
    wellPropertiesForm.data.value?.hps_liquid_type === Hps_Liquid_Type_Enum.Oil
  );
});

const { isScenarioReadonly, isImportedFromLegacy } = useEditPermissions();
</script>
